







































































































































































































































import PartnerDetailAttributeWithToolTip from "@/components/partner/PartnerDetailAttributeWithToolTip.vue";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { activityLogName } from "@/lib/utility/activityLogName";
import { detailedDate } from "@/lib/utility/date-helper";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import FeatureMixin from "@/mixins/FeatureMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IActivityLog } from "@/models/activity-log.entity";
import { ActivityLogModule } from "@/store/modules/activity-log.store";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import TimeLineItemText from "../utility/TimeLineItemText.vue";
import ActivityTimeLineItemAssignees from "./ActivityTimeLineItemAssignees.vue";
import ActivityTimeLineItemTags from "./ActivityTimeLineItemTags.vue";
import ActivityTimeLineItemAttachmentResponse from "./ActivityTimeLineItemAttachmentResponse.vue";
import ActivityTimeLineItemComment from "./ActivityTimeLineItemComment.vue";
import ActivityTimeLineItemCreateCost from "./ActivityTimeLineItemCreateCost.vue";
import ActivityTimeLineItemCreated from "./ActivityTimeLineItemCreated.vue";
import ActivityTimeLineItemDocument from "./ActivityTimeLineItemDocument.vue";
import ActivityTimeLineItemEventSeries from "./ActivityTimeLineItemEventSeries.vue";
import ActivityTimeLineItemImage from "./ActivityTimeLineItemImage.vue";
import ActivityTimeLineItemIsFixedUpdate from "./ActivityTimeLineItemIsFixedUpdate.vue";
import ActivityTimeLineItemMessage from "./ActivityTimeLineItemMessage.vue";
import ActivityTimeLineItemProgressStatusMessage from "./ActivityTimeLineItemProgressStatusMessage.vue";
import ActivityTimeLineItemReportStatusUpdate from "./ActivityTimeLineItemReportStatusUpdate.vue";
import ActivityTimeLineItemReportUpdate from "./ActivityTimeLineItemReportUpdate.vue";
import ActivityTimeLineItemShareLink from "./ActivityTimeLineItemShareLink.vue";
import ActivityTimeLineItemSignRequest from "./ActivityTimeLineItemSignRequest.vue";
import ActivityTimeLineItemTicket from "./ActivityTimeLineItemTicket.vue";
import ActivityTimeLineItemReportSummaryCreated from "./ActivityTimeLineReportSummaryCreated.vue";
import BaseActivityTimeLineItem from "./BaseActivityTimeLineItem.vue";
import ActivityTimeLineItemManageTargetsOnSource from "./ActivityTimeLineItemManageTargetsOnSource.vue";
import ActivityTimeLineItemManagePropertiesOnSource from "./ActivityTimeLineItemManagePropertiesOnSource.vue";
import ActivityTimeLineItemCreateRef from "./ActivityTimeLineItemCreateRef.vue";
import ActivityTimeLineHistoryStatus from "./ActivityTimeLineHistoryStatus.vue";
import ActivityTimeLineItemAssociated from "./ActivityTimeLineItemAssociated.vue";

@Component({
  components: {
    PartnerDetailAttributeWithToolTip,
    BaseActivityTimeLineItem,
    ActivityTimeLineItemSignRequest,
    ActivityTimeLineItemComment,
    ActivityTimeLineItemReportStatusUpdate,
    ActivityTimeLineItemMessage,
    ActivityTimeLineItemProgressStatusMessage,
    ActivityTimeLineItemIsFixedUpdate,
    ActivityTimeLineItemShareLink,
    ActivityTimeLineItemAttachmentResponse,
    ActivityTimeLineItemReportUpdate,
    ActivityTimeLineItemDocument,
    ActivityTimeLineItemCreated,
    ActivityTimeLineItemCreateCost,
    ActivityTimeLineItemTicket,
    ActivityTimeLineItemImage,
    ActivityTimeLineItemEventSeries,
    ActivityTimeLineItemAssignees,
    ActivityTimeLineItemTags,
    ActivityTimeLineItemReportSummaryCreated,
    ActivityTimeLineItemManageTargetsOnSource,
    ActivityTimeLineItemManagePropertiesOnSource,
    ActivityTimeLineItemCreateRef,
    ActivityTimeLineHistoryStatus,
    ActivityTimeLineItemAssociated,
    TimeLineItemText
  }
})
export default class ActivityTimeLine extends mixins(DarkModeHighlightMixin, PermissionMixin, FeatureMixin) {
  @Prop()
  activities?: IActivityLog[];

  @Prop({ default: true }) //ToDo DEFAULT TO FALSE
  truncate!: boolean;

  get activityLogTruncated() {
    const activities = this.activityLog;

    if (this.truncate) {
      return activities.slice(0, this.windowSize);
    }
    return activities;
  }

  get activityLog() {
    if (this.activities) {
      return this.activities;
    }
    return ActivityLogModule.filteredAndSorted;
  }

  get ActivityTypeEnum() {
    return ActivityTypeEnum;
  }

  windowSize = 5;

  increaseWindow() {
    this.windowSize += 5;
  }

  activityLogName(activityLogEntry: IActivityLog) {
    return activityLogName(activityLogEntry);
  }

  detailedDate(date: string) {
    return detailedDate(date);
  }
}
